import React from "react";

export default function OrderDetailsModal({ open, onClose, order }) {
  if (!open || !order) return null;

  console.log('Order in modal:', order);

  const BACKEND_BASE_URL =
    process.env.NODE_ENV === 'production'
      ? 'https://teenagefashion.in'
      : 'http://localhost/newfashion';

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40 px-2 modal-open-block-swipe" onClick={onClose}>
      <div
        className="bg-white rounded-xl shadow-lg max-w-md w-full p-5 relative"
        onClick={e => e.stopPropagation()}
      >
        <button
          className="absolute top-2 right-2 text-gray-400 hover:text-gray-700 text-xl font-bold"
          onClick={onClose}
          aria-label="Close"
        >
          &times;
        </button>
        <h2 className="text-lg font-bold mb-2 text-gray-800">Order Details</h2>
        {/* Show order image if available */}
        {order.image_path && (
          <div className="mb-4 flex flex-col items-center">
            <span className="font-semibold text-gray-700 mb-1">Order Image:</span>
            <img
              src={order.image_path.startsWith('http') ? order.image_path : `${BACKEND_BASE_URL}/${order.image_path}`}
              alt="Order"
              className="w-40 h-40 object-cover rounded border"
              style={{ maxWidth: '100%', maxHeight: '160px' }}
            />
          </div>
        )}
        <div className="mb-2">
          <span className="font-semibold text-gray-700">Order ID:</span> {order.id}
        </div>
        <div className="mb-2">
          <span className="font-semibold text-gray-700">Customer Name:</span> {order.name}
        </div>
        {order.phone && (
          <div className="mb-2">
            <span className="font-semibold text-gray-700">Phone:</span> {order.phone}
          </div>
        )}
        <div className="mb-2">
          <span className="font-semibold text-gray-700">Delivery Date:</span> {order.delivery_date}
        </div>
        <div className="mb-2">
          <span className="font-semibold text-gray-700">Status:</span> {order.status}
        </div>
        <div className="mb-2">
          <span className="font-semibold text-gray-700">Quantity:</span> {order.quantity}
        </div>
        {order.fabric_type && (
          <div className="mb-2">
            <span className="font-semibold text-gray-700">Fabric Type:</span> {order.fabric_type}
          </div>
        )}
        {order.color && (
          <div className="mb-2">
            <span className="font-semibold text-gray-700">Color:</span> {order.color}
          </div>
        )}
        {order.note && (
          <div className="mb-2">
            <span className="font-semibold text-gray-700">Note:</span> {order.note}
          </div>
        )}
      </div>
    </div>
  );
} 